<template>
    <v-container fluid style="height: 100%" class="px-4">
        <h1>Arup Compute Statistics</h1>
        <FunctionPopularity />
    </v-container>
</template>
<script setup>
import FunctionPopularity from './FunctionPopularity.vue'
</script>
